import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const WorkflowHeader = () => {
    return (_jsxs("div", { className: "email-credentials__header", children: [_jsx("h2", { className: "email-credentials__title", children: "Email Credentials" }), _jsx("p", { className: "email-credentials__description", children: "Bulk send credential emails to PerfectServe users from an XLSX file containing V5UserIds or IdentityIds." })] }));
};
